"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeLoader = exports.initialiseLoader = exports.buildLoaderStyles = exports.buildLoaderComponent = exports.BUILD_LOADER_ELEMENT_STYLE = exports.BUILD_LOADER_CONTAINER_ID = exports.BUILD_LOADER_ELEMENT_ID = void 0;
exports.BUILD_LOADER_ELEMENT_ID = 'fluid-build-loader-element';
exports.BUILD_LOADER_CONTAINER_ID = 'fluid-build-loader-container';
exports.BUILD_LOADER_ELEMENT_STYLE = 'fluid-build-loader-style';
const LOADER_ELEMENT = typeof window !== "undefined" && !!document ? document === null || document === void 0 ? void 0 : document.getElementById(exports.BUILD_LOADER_ELEMENT_ID) : null;
const LOADER_STYLE = typeof window !== "undefined" && !!document ? document === null || document === void 0 ? void 0 : document.getElementById(exports.BUILD_LOADER_ELEMENT_STYLE) : null;
function buildLoaderComponent() {
    const div = document.createElement('div');
    div.id = exports.BUILD_LOADER_ELEMENT_ID;
    div.className = exports.BUILD_LOADER_CONTAINER_ID;
    div.style.display = 'block';
    div.style.position = 'absolute';
    div.style.top = '0';
    div.style.bottom = '0';
    div.style.right = '0';
    div.style.left = '0';
    div.style.backdropFilter = 'blur(30px)';
    div.style.paddingTop = '50vh';
    div.style.zIndex = '999999999';
    const loader = document.createElement('div');
    loader.className = 'loader';
    div.appendChild(loader);
    return div;
}
exports.buildLoaderComponent = buildLoaderComponent;
function buildLoaderStyles() {
    const styleSheet = document.createElement('style');
    styleSheet.id = exports.BUILD_LOADER_ELEMENT_STYLE;
    styleSheet.textContent = `     
       .loader {
            width: 22px;
            aspect-ratio: 1;
            border-radius: 50%;
            border: 3px solid lightgray;
            border-right-color: #a0a0a0;
            animation: l2 1s infinite linear;
            display: block;
            margin: 0 auto;
       }
       @keyframes l2 {to{transform: rotate(1turn)}}`;
    return styleSheet;
}
exports.buildLoaderStyles = buildLoaderStyles;
function initialiseLoader(timeout = 0) {
    if (typeof window !== "undefined" && !!document) {
        if (!LOADER_STYLE) {
            document.head.appendChild(buildLoaderStyles());
        }
        if (!LOADER_ELEMENT) {
            document.body.appendChild(buildLoaderComponent());
        }
        window.addEventListener('appload', (loadTag) => {
            const event = loadTag;
            if (event.detail.namespace === 'fluid') {
                setTimeout(() => removeLoader(), timeout);
            }
        });
    }
}
exports.initialiseLoader = initialiseLoader;
function removeLoader() {
    const styles = LOADER_STYLE;
    if (LOADER_STYLE) {
        // @ts-ignore
        styles.parentNode.removeChild(styles);
    }
    document.querySelectorAll(`div.${exports.BUILD_LOADER_CONTAINER_ID}`).forEach((element) => {
        if (element.parentNode) {
            element.parentNode.removeChild(element);
        }
        else {
            element.style.display = 'none';
        }
    });
}
exports.removeLoader = removeLoader;
